import { useCallback } from 'react';

import { useUserMenuDataShapes } from '../../../controllers/user-state/user-menu-data-shapes-provider';
import type { CustomizationModalProps } from '../../../ui/customization-modal/types';
import type { ExtendedUserMenuData, UserMenuData } from '../../types';

export const useOnSave = (): CustomizationModalProps['onSave'] => {
	const { setUserMenuData } = useUserMenuDataShapes();

	return useCallback(
		async (
			updatedItemExtendedUserMenuData: ExtendedUserMenuData,
			updatedShortcutExtendedUserMenuData: ExtendedUserMenuData,
		) => {
			// Put the data back together and remove extra properties
			const userMenuData: UserMenuData = updatedItemExtendedUserMenuData
				.concat(updatedShortcutExtendedUserMenuData)
				.map(({ menuId, visible }) => ({ menuId, visible }));

			setUserMenuData(userMenuData);
		},
		[setUserMenuData],
	);
};
